module.exports = __webpack_public_path__ + "static/media/product_add_item.9abb513b.svg";